module.exports = __webpack_public_path__ + "img/ngr_nxr_5A.6ab7b1ce.png";